import { render, staticRenderFns } from "./ButtonEditSave.vue?vue&type=template&id=0d53f3d4"
import script from "./ButtonEditSave.vue?vue&type=script&lang=js"
export * from "./ButtonEditSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports